import React from "react";
import ChartModal from "./ChartModal";
import LeaderRankBarChart from "./LeaderRankBarChart";
import "./LeaderRankBarChartModal.css";

const LeaderRankBarChartModal = ({
  isOpen,
  onClose,
  data,
  excludedDomains = [],
  title,
}) => (
  <ChartModal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    className="leader-rank-bar-chart-modal-content"
  >
    <LeaderRankBarChart
      data={data}
      excludedDomains={excludedDomains}
      maxItems={Infinity}
    />
  </ChartModal>
);

export default LeaderRankBarChartModal;
